var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetPaginationLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.5C0 2.29086 1.79086 0.5 4 0.5H28C30.2091 0.5 32 2.29086 32 4.5V28.5C32 30.7091 30.2091 32.5 28 32.5H4C1.79086 32.5 0 30.7091 0 28.5V4.5Z",
    fill: "#E9DFDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4701 12.0283C18.7305 12.2886 18.7305 12.7107 18.4701 12.9711L14.9415 16.4997L18.4701 20.0283C18.7305 20.2886 18.7305 20.7107 18.4701 20.9711C18.2098 21.2314 17.7876 21.2314 17.5273 20.9711L13.5273 16.9711C13.2669 16.7107 13.2669 16.2886 13.5273 16.0283L17.5273 12.0283C17.7876 11.7679 18.2098 11.7679 18.4701 12.0283Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetPaginationLeft);
export default __webpack_public_path__ + "static/media/targetPaginationLeft.c532a7f3f4ca24e973d5daebf2bb05d0.svg";
export { ForwardRef as ReactComponent };